'use client';

import type {ProductFilters} from '@/modules/commerce/filters/query';
import type {HeadingLevel} from '@/modules/foundation/components/typography/heading';

import {searchParamsFromProductConfiguration} from '../../configuration';
import ProductCardBase from '../../ProductCardBase';
import {PRODUCT_PAGE_ALL_SLUG} from '../../schema/constants';
import {
	getNonOpinionatedStickerConfigurationAppropriateForFilters,
	getStickerBrandsFromConfiguration,
	getStickerConfigurationAppropriateForFilters,
} from '../configuration/stickerProductConfiguration';
import type {StickerProductFragment} from '../query';

type StickerProductCardProps = {
	headingLevel: HeadingLevel;
	fragment: StickerProductFragment;
	filters?: ProductFilters;
};

export default function StickerProductCard({
	headingLevel,
	fragment,
	filters,
}: StickerProductCardProps) {
	const configuration = getStickerConfigurationAppropriateForFilters(fragment, filters);
	const configurationNonOpinionated = getNonOpinionatedStickerConfigurationAppropriateForFilters(
		fragment,
		filters,
	);
	const params = searchParamsFromProductConfiguration(configuration);
	const brands = getStickerBrandsFromConfiguration(fragment, configurationNonOpinionated);
	const href = `/${PRODUCT_PAGE_ALL_SLUG}/${fragment.fullSlug}?${params.toString()}`;

	return (
		<ProductCardBase
			href={href}
			product={fragment}
			configuration={configurationNonOpinionated}
			headingLevel={headingLevel}
			brands={brands}
			isConfigurable
		/>
	);
}
